<ng-container *transloco="let t">
  @if (isAdmin) {
    @if (activeFilterGroups && filteringEnabled) {
        <app-filter-panel
            [groups]="activeFilterGroups! | mapToArray"
            [showFilterChips]="false"
            [minTextSearchLength]="isAdmin ? MIN_SEARCH_INPUT_LENGTH_ADMIN : MIN_SEARCH_INPUT_LENGTH "
            (filterChange)="onFilterChange($event)"
        >
            <div slot="filterTrailing">
                <ng-content select="[slot='resultsTableAdminTrailingWidgets']"></ng-content>
            </div>
        </app-filter-panel>
        }
  }
  <div class="results-table" infinite-scroll
       [infiniteScrollDistance]="1"
       (scrolled)="loadMore()">
    @if (filteringEnabled && !isAdmin) {
      <!-- Filter part for public-->
      @if (activeFilterGroups) {
      <app-filter-panel
              [groups]="activeFilterGroups! | mapToArray"
              [showFilterChips]="false"
              [minTextSearchLength]="isAdmin ? MIN_SEARCH_INPUT_LENGTH_ADMIN : MIN_SEARCH_INPUT_LENGTH "
              (filterChange)="onFilterChange($event)"
      />
      }
    }
    <ng-content/>
    @if (results?.length ?? 0 > 0) {
        @for (competitor of results;track competitor) {
          <!--              Mobile list item-->
          <div class="d-flex flex-column d-flex d-lg-none">
              <app-results-table-mobile-list-item [competitor]="competitor"
                                                  [isRound]="isRound"
                                                  [category]="competitorFiler.categories?.at(0)"
                                                  [gender]="competitorFiler.gender" [measurementType]="measurementType"
                                                  [firstCompetitorResults]="firstCompetitorResults"
                                                  [isAdmin]="isAdmin"
                                                  [race]="race" [isLast]="$last"
                (onOpenDetails)="openDetailsModal(competitor)"
              ></app-results-table-mobile-list-item>
          </div>
        }

        <div class="d-none d-lg-flex position-relative">
          <div class="d-flex flex-column scroll-btn-box">
            <button class="scroll-btn" (click)="scrollTable(true)">
              <img src="assets/icons/icons-alt/arrow-right.svg" alt="Scroll table right">
            </button>
            <button class="scroll-btn" (click)="scrollTable(false)">
              <img src="assets/icons/icons-alt/arrow-left.svg" alt="Scroll table left">
            </button>
          </div>

          <div class="table-responsive table-responsive--addon">
            <table class="table align-middle">
              <thead>
              <tr>
                <th scope="col" class="rank-column-width">{{t("competitor.table.absolute.rank")}}</th>
                <th scope="col" class="start-number-column-width">{{t('competitor.table.start.number')}}</th>
                <th scope="col" class="name-column-width">{{t('app.common.competitor')}}</th>
                <th scope="col" class="status-col-width">{{t('competitor.table.status')}}</th>
                <th scope="col" class="time-column-width">{{t('competitor.table.time')}}</th>
                <th scope="col" class="gap-column-width">{{t('competitor.table.gap')}}</th>
                @if (race?.raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
                  <th scope="col" class="status-col-width">{{t('competitor.table.distance')}}</th>
                }
                <th scope="col" class="cp-column-width">{{
                    isRound ?
                    t('competitor.table.laps') : t('competitor.table.cp')
                  }}
                </th>

                @if (!isRound) {
                  <th scope="col" class="cp-location-col-width">{{
                      t('organiser.event.details.control.point.waypointType.3')
                    }}
                  </th>
                  @if (controlWaypoints?.length ?? 0 > 0) {
                    @for (cp of controlWaypoints;track cp) {
                      <th scope="col" class="cp-location-col-width">
                        <div class="cp-location-col-width__trim">
                          {{
                            controlWaypoints | waypointNameById:cp.id
                          }}
                        </div>
                      </th>
                    }
                  }
                  <th scope="col" class="cp-location-col-width">{{
                      t('organiser.event.details.control.point.waypointType.4')
                    }}
                  </th>
                }
              </tr>
              </thead>
              <tbody #tbody>
                @for (competitorResults of results;track competitorResults) {
                  <tr>
                    <td class="rank-column-width">{{competitorResults | rank:competitorFiler.categories?.at(0):competitorFiler.gender:measurementType}}</td>
                    <td class="start-number-column-width">
                      <div class="start-number-badge" (click)="openDetailsModal(competitorResults)">
                        {{competitorResults.startNumber}}
                        <span class="ps-1">
                          <img src="assets/icons/icons-alt/search-list-02.svg" alt="Open details"/>
                        </span>
                      </div>
                    </td>
                    <td class="name-column-width">
                      <div class="d-flex flex-row align-items-center">
                        @if (Array.isArray(competitorResults?.competitorResultsDetail?.team) &&
                        competitorResults!.competitorResultsDetail!.team!.length > 0) {
                          <div class="d-flex flex-column">
                            <span class="fw-500">
                                {{  t("app.common.team") + " " + ((competitorResults?.lastName ?? "") | titlecase) }}
                            </span>
                          @for (member of competitorResults?.competitorResultsDetail?.team;track member) {
                              <span>
                              {{
                                  ((member?.fn ?? "") | titlecase) + " " + ((member?.ln ?? "") | titlecase)
                                }}
                            </span>
                            }
                          </div>
                        } @else {
                          {{
                            ((competitorResults?.firstName ?? "")| titlecase) + " " + ((competitorResults?.lastName
                              ?? "") | titlecase)
                          }}
                        }
                        @if (!(Array.isArray(competitorResults?.competitorResultsDetail?.team)
                          && competitorResults!.competitorResultsDetail!.team!.length > 0)) {
                          <div class="d-flex justify-content-center justify-content-start ps-2">
                            @if (competitorResults.sex === 1) {
                              <div class="badge-holder__badge gender-badge-man me-1">
                              <span class="text-uppercase">
                                {{t("app.common.gender.short.1")}}
                              </span>
                              </div>
                            } @else if (competitorResults.sex === 2) {
                              <div class="badge-holder__badge gender-badge-women me-1">
                              <span class="text-uppercase">
                                {{t("app.common.gender.short.2")}}
                              </span>
                              </div>
                            } @else {
                              <div class="badge-holder__badge gender-badge-man me-1">
                              <span class="text-uppercase">
                                {{"-"}}
                              </span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <div class="badge-holder__badge finished">
                          <span class="text-uppercase">
                            {{
                              competitorResults.status ? competitorResults.status : "-"
                            }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}</td>
                    <td>{{
                        competitorResults.competitorResultsDetail |
                          resultsGapTime:firstCompetitorResults?.competitorResultsDetail:measurementType:race?.raceSettings?.measurementPrecisionType
                      }}
                    </td>
                    @if (race?.raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
                    <td  class="text-center">{{ competitorResults.competitorResultsDetail?.distance | raceLengthFormat:undefined:"m" }}</td>
                    }
                    <td
                      class="text-center">{{competitorResults.competitorResultsDetail | nmControlPointsOrLaps:isRound}}
                    </td>
                    @if (!isRound) {
                      <td>{{
                          competitorResults?.competitorResultsDetail?.st_tm|
                            resultDateTime:competitorResults?.competitorResultsDetail?.st_dc:race?.raceSettings?.measurementPrecisionType
                        }}
                      </td>
                      @if (controlWaypoints?.length ?? 0 > 0) {
                        @for (cp of controlWaypoints;track cp) {
                          <td>
                            @if (competitorResults?.competitorResultsDetail?.SGS &&
                            competitorResults?.competitorResultsDetail?.SGS![cp.id!]) {
                              <div>{{
                                  competitorResults?.competitorResultsDetail?.SGS![cp.id!].ps_tm|
                                    resultDateTime:competitorResults?.competitorResultsDetail?.SGS![cp.id!].ps_dc:race?.raceSettings?.measurementPrecisionType
                                }}
                              </div>
                              <div>{{competitorResults?.competitorResultsDetail?.SGS![cp.id!].nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}</div>
                              <div>{{
                                  '('
                                  + (competitorResults?.competitorResultsDetail?.SGS![cp.id!].tl_tm|resultTime:race?.raceSettings?.measurementPrecisionType)
                                  +
                                  ')'
                                }}
                              </div>
                              <div class="d-flex flex-row">
                                <div class="badge-holder__badge rank-badge">
                                  <span class="text-uppercase">
                                    {{competitorResults?.competitorResultsDetail?.SGS![cp.id!] | rank:competitorFiler.categories?.at(0):competitorFiler.gender:measurementType:true}}
                                  </span>
                                </div>
                              </div>
                            }
                          </td>
                        }
                      }
                      <td>
                        @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                          <div>{{
                              competitorResults?.competitorResultsDetail?.fn_tm|
                                resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType
                            }}
                          </div>
                          @if ((controlWaypoints?.length ?? 0) > 0 && competitorResults.status
                          === CompetitorStatus.FIN) {
                            <div>{{
                                '('
                                + (competitorResults?.competitorResultsDetail?.SGS|finishAndLastCpDiff:race?.raceSettings?.measurementPrecisionType)
                                + ')'
                              }}
                            </div>
                          }
                          <div>{{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}</div>
                          <div class="d-flex flex-row">
                            <div class="badge-holder__badge rank-badge">
                            <span class="text-uppercase">
                              {{competitorResults | rank:competitorFiler.categories?.at(0):competitorFiler.gender:measurementType}}
                            </span>
                            </div>
                          </div>
                        } @else {
                          {{"-"}}
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="sticky-shadow"></div>
        </div>
    } @else if (!isLoading) {
      <div class="px-0 pt-2">
        <app-empty-state [contentKeys]="['emptyState.not.able.to.find', 'emptyState.not.in.progress.try.later']"/>
      </div>
    }
  </div>
</ng-container>

